import * as React from 'react';
import DashboardNumbersContainer from '~/containers/Dashboard/DashboardNumbers';

import { t } from '~/i18n';
import { Panel } from '@watcherr/ui';
import DashboardAlertListContainer from '~/containers/Dashboard/DashboardAlertList';
import AlertStatusContainer from '~/containers/Alerts/AlertStatus';
import DashboardAlertActivityContainer from '~/containers/Dashboard/AlertActity';
import UserNotifications from '~containers/UI/UserNotifications';
import DashboardView from '~components/DashboardView';
import { useStores } from '~store/utils';
import { observer } from 'mobx-react';
import { Site } from '@watcherr/resources';

const DashboardPage = observer(() => {
  const { auth } = useStores();
  const title = t('menu.dashboard.dashboard') + ' · ' + (auth.user?.site?.name ?? '');

  React.useEffect(() => {
    if (title) {
      document.title = t('meta.title', { title });
    }
  }, [title]);

  return (
    <>
      <DashboardView title={title}>
        <UserNotifications>
          <div className="mb-30">
            <DashboardNumbersContainer />
          </div>
          <div className="row">
            <div className="col-md-8 mb-30">
              <Panel>
                <Panel.Title>{t('dashboard.panels.alertActivity')}</Panel.Title>
                <DashboardAlertActivityContainer />
              </Panel>
            </div>
            <div className="col-md-4 mb-30">
              <Panel>
                <AlertStatusContainer />
              </Panel>
            </div>
          </div>
          <Panel>
            <Panel.Title>{t('dashboard.panels.recentAlerts')}</Panel.Title>
            <DashboardAlertListContainer getSiteConfig={Site.getSiteConfiguration} />
          </Panel>
        </UserNotifications>
      </DashboardView>
    </>
  );
});

export default DashboardPage;
